<template>
  <div class="atividades-monitoramentoescala ml-4 mr-4" >
      <b-form> 

          <b-row>
              <b-col cols="1" class="mt-2 pr-4" >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                         
                        class="mb-2" 
                        v-model="operador.foto_url"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="operador.foto_url"
                    >
                    </b-img>
                  </b-form-group>
                  
              </b-col>  
             
              <b-col>

                <!-- NOME -->     
                <b-row >
                    <b-col cols=4 class="mt-3 ">
                        <label  for="input-busca">Nome</label>  
                        <b-form-input id="fot-nome" 
                            type="text" 
                            readonly                       
                            v-model="operador.nome_completo"                         
                            placeholder="Nome do funcionário" 
                        />                        
                    </b-col>

                    <b-col cols=1 class="mt-3 ">
                        <label  for="input-busca">Admissão</label>      
                            <b-form-input
                        id="fot-admissao"
                        :value="formattedDate"
                        readonly
                        />                                         
                    </b-col>                     

                </b-row>


                <!-- FUNÇÃO e CHN -->     
                <b-row >
                   
                    <b-col cols=2 class="mt-2">
                        <label  for="input-busca">Função</label>  
                        <b-form-input id="fot-funcao" 
                            type="text"   
                            readonly                     
                            v-model="operador.funcao"                         
                            placeholder="Função" 
                        />                        
                    </b-col>
  
                      <b-col cols=2 class="mt-2">       
                        <label  for="input-busca">Celular</label>                   
                        <b-form-input id="fot-celular" only
                            type="text"
                            readonly   
                            v-mask="'#####-###'"                     
                            v-model="operador.celular"                         
                            placeholder="Nº do celular" 
                        />
                    </b-col>     

                    
                    <b-col cols=1 class="mt-2">       
                        <label  for="input-busca">Versão APP</label>                   
                        <b-form-input id="fot-celular" only
                            type="text"
                            readonly   
                            v-mask="'#####-###'"                     
                            v-model="operador.versao_app"                         
                            placeholder="Versão app" 
                        />
                    </b-col>     
                                                                  
                </b-row>

                <!-- RE e CELULAR -->     
               
                <b-row >
                    <b-col cols=1 class="mt-4">
                      <label  for="input-busca">Registro</label>  
                        <b-form-input id="fot-registro" 
                            type="text"
                            required                        
                            v-model="registro"                             
                            placeholder="Registro" 
                        />                        
                    </b-col> 
                    
                    <b-col cols=2 class="mt-4">
                        <div>   <label  for="input-busca">Selecione uma data</label>  
                                <b-form-datepicker id="esc_data_servico"  v-model="data_operacao"  required placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                            </div>                     
                    </b-col>     

            


                <b-col cols=1 class="mt-4">
                    <label  for="input-busca"></label> 
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" block @click="carregando = true,loadOperador(),loadAuditoriaUsoApp()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                    </b-button>   
                </b-col>

                <b-col cols=1 class="mt-4">
                   <label  for="input-busca"></label> 
                       
                <b-button  variant="success" class="mr-2 mt-2" block @click="gerarPlanilha()">
                  Gerar planilha
                </b-button>                      
              </b-col>


                <b-col cols="5">
                    <b-col class="mb-0 mt-4">
                        <label  for="input-busca">Filtrar no grid  </label>  
                        <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Registro / Programa / Observações"></b-form-input>              
                    </b-col>                 
                </b-col>


                <LoadingModal v-if="isLoading" />
             
                </b-row>

                            


              </b-col>              
          </b-row>

          
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="888px"  :items="itemsFiltered" :fields="fields">                           
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'



export default {    
    name: 'TraAtividadesProgramadasRealizadas',

    data: function() {
        return {
            mode: 'save',
            isLoading: false,
            carregando: false,
            filtro: false,
            operadores:{},
            operador: [],            
            escala:[],
            data_operacao: '',
            search:'',

            




            mainProps: { blankColor: '#777', width: 157, height: 161, class: 'm1' },


            
            fields: [
                

              { key: 'filial', label: 'filial', sortable: true },
                { key: 'dt_acesso', label: 'Data acesso', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.dt_acesso).format('DD/MM/YYYY HH:mm');} },
                { key: 'registro', label: 'Registro', sortable: true },           
                { key: 'funcao', label: 'Função', sortable: true },           
                { key: 'tipo', label: 'Origem do acesso', sortable: true }, 
                { key: 'modulo', label: 'Módulo', sortable: true },
                { key: 'programa', label: 'Programa', sortable: true },
                { key: 'observacoes', label: 'Observações', sortable: true, formatter: this.formatObservacoes },
                { key: 'ip', label: 'Endereço de acesso IP', sortable: true },           
                
                

            //    { key: 'observacoes', label: 'Observações', sortable: true },
           //     { key: 'ip', label: 'IP de acesso', sortable: true },
               

               
                
            ]
        }        
    },

    //computed: mapState(['user']),
        computed : { ... mapState (['user'],),
         formattedDate() {
      return  this.operador.dt_admissao != null ?  moment(this.operador.dt_admissao).format('DD/MM/YYYY') : '';
    },
    
      itemsFiltered(){
        let valores = [];       
        valores = this.escala.filter((item) =>{ 
          const observacoes = item.motprogramado || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const programa = item.motrealizado || '';
          const registro = item.cobprogramado || '';
          
           return (
            item.observacoes.toLowerCase().includes(this.search.toLowerCase()) ||            
            item.programa.toLowerCase().includes(this.search.toLowerCase()) ||            
            item.registro.toLowerCase().includes(this.search.toLowerCase()) ||            
            observacoes.indexOf(this.search) >-1 ||
            programa.indexOf(this.search) >-1 ||
            registro.indexOf(this.search) >-1 
          );
        });
           return valores
        },

   
    } ,

    components: {LoadingModal    },
    methods: {

            formatObservacoes(value) {
      return value == null ? '-' : value;
    },


        async loadOperador() { 
            let corpo = {                             
            "registro": `${this.registro}`,
            "id_empresa": `${this.user.id_empresa}`
            }; 
            
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo).then(res => { this.operador = res.data })   
                      this.carregando = false;       
                      this.escala = []
        },  

        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.escala

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'apps_auditoria.xlsx');
      },
/*
        async loadAuditoriaUsoApp() { 
            this.isLoading = true; // Ative o indicador de carregamento                                    
            let corpo = {                
            "id_empresa": `${this.user.id_empresa}`,
            "registro": `${this.registro}`,
            "filtro": `${this.filtro}`,
            "dt_visualizacao": `${this.moment(this.data_operacao).format('DD/MM/YYYY')}`                     
          }; 
          const url = `${baseApiUrl}/informatica/auditoriausoapp`
          axios.post(url,corpo)
          .then(res => {
            this.carregando = false;               
            this.escala = res.data 
             this.isLoading = false; // Desative o indicador de carregamento   
             this.registro = '';
             this.data_operacao = '';
             console.log('Tamanho do objeto '+ this.escala.length)

            })          
        .catch(showError)
            
        }, 
*/
async loadAuditoriaUsoApp() { 
  this.isLoading = true; // Ative o indicador de carregamento                                    
  let corpo = {                
    "id_empresa": `${this.user.id_empresa}`,
    "registro": `${this.registro}`,
    "filtro": this.registro.length > 0 || this.registro !="" || this.registro !="undefined" ? "true" : "false",
    "dt_visualizacao": `${this.moment(this.data_operacao).format('DD/MM/YYYY')}`                     
  }; 
  const url = `${baseApiUrl}/informatica/auditoriausoapp`;
  
  try {
    const res = await axios.post(url, corpo);
    this.carregando = false;               
    this.escala = res.data;
    this.isLoading = false; // Desative o indicador de carregamento   
    this.registro = '';
    this.data_operacao = '';
    
    if (this.escala.length === 0) {
      console.log('O objeto escala está vazio');
      // Você pode adicionar uma mensagem de alerta ou algum outro tratamento aqui
      alert('Nenhum registro encontrado.');
    } 
    /*else {
      console.log('Tamanho do objeto ' + this.escala.length);
    }
    */
  } catch (error) {
    this.isLoading = false; // Desative o indicador de carregamento em caso de erro
    showError(error);
  }
}



        
       
    },

    mounted() { 
       // this.loadFormatarData()
       //this.loadOperador()           
       //this.loadAuditoriaUsoApp()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>

